import { Chip } from '@mui/material'

import { DiscountCode } from '../../../../redux/states/admin/payments/discountCodes/getDiscountCodesForAdmin/getDiscountCodesForAdmin.types'
import { FormSection } from '../../../../shared/components/Form/Form.types'
import { TableColumn } from '../../../../shared/components/Table/Table.types'
import date, { dateTimeFormats } from '../../../../shared/functions/Date/date.functions'
import { changeCase, formatMoney } from '../../../../shared/functions/String/string.functions'

export const discountCodesTableColumns: TableColumn<DiscountCode>[] = [
  { key: 'code', label: 'Code' },
  {
    key: 'type',
    label: 'Type',
    render: (row: DiscountCode) => changeCase(row.type).sentence
  },
  {
    key: 'amount',
    label: 'Discount Value',
    render: (row: DiscountCode) =>
      row.type === 'percentage' ? `${row.amount}%` : formatMoney(row.amount, row.currency)
  },
  {
    key: 'createdAt',
    label: 'Start Date',
    render: (row: DiscountCode) => date(row.createdAt).format(dateTimeFormats.date.medium)
  },
  {
    key: 'expiresAt',
    label: 'Expiry Date',
    render: (row: DiscountCode) => date(row.expiresAt).format(dateTimeFormats.date.medium)
  },
  // {
  //   key: 'totalUses',
  //   label: 'Total Uses',
  //   render: () => '0' // TODO: Add usage tracking when available
  // },
  {
    key: 'status',
    label: 'Status',
    render: (row: DiscountCode) => {
      const now = new Date()
      const expiryDate = new Date(row.expiresAt)
      const isActive = expiryDate >= now

      return <Chip label={isActive ? 'Active' : 'Expired'} color={isActive ? 'success' : 'error'} />
    }
  }
]

export const createDiscountCodeFormFieldsSections: FormSection[] = [
  {
    title: 'Basic Information',
    alignment: 'left',
    fields: [
      {
        name: 'code',
        label: 'Discount Code',
        type: 'text',
        placeholder: 'Enter discount code (e.g., SAVE20)',
        required: true,
        fullWidth: true,
        grid: { xs: 12, sm: 12 }
      },
      {
        name: 'description',
        label: 'Description',
        type: 'text',
        placeholder: 'Enter description (optional)',
        fullWidth: true,
        grid: { xs: 12, sm: 12 }
      }
    ]
  },
  {
    title: 'Discount Details',
    alignment: 'left',
    fields: [
      {
        name: 'discountType',
        label: 'Discount Type',
        type: 'select',
        required: true,
        fullWidth: true,
        grid: { xs: 12, sm: 6 },
        options: [
          { value: 'percentage', label: 'Percentage (%)' },
          { value: 'fixed', label: 'Fixed Amount ($)' }
        ]
      },
      {
        name: 'discountValue',
        label: 'Discount Value',
        type: 'number',
        placeholder: 'Enter discount value',
        required: true,
        fullWidth: true,
        grid: { xs: 12, sm: 6 }
      }
    ]
  },
  {
    title: 'Validity Period',
    alignment: 'left',
    fields: [
      {
        name: 'startDate',
        label: 'Start Date',
        type: 'date',
        required: true,
        fullWidth: true,
        grid: { xs: 12, sm: 6 }
      },
      {
        name: 'expiryDate',
        label: 'Expiry Date',
        type: 'date',
        required: true,
        fullWidth: true,
        grid: { xs: 12, sm: 6 }
      }
    ]
  }
]
